import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, I18nModule, UrlModule, provideConfig } from '@spartacus/core'
import { CarouselModule, MediaModule } from '@spartacus/storefront'
import { CustomProductCarouselComponent } from './custom-product-carousel.component'

@NgModule({
  imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductCarouselComponent: {
          component: CustomProductCarouselComponent
        }
      }
    })
  ],
  declarations: [CustomProductCarouselComponent],
  exports: [CustomProductCarouselComponent]
})
export class CustomProductCarouselModule {}
